import BankCodeInput from "./bankCodeInput";

export default class CcInput<TTarget> extends BankCodeInput<TTarget> {
  protected mask = ["0", /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
}
